import { render, staticRenderFns } from "./UploadFolder.vue?vue&type=template&id=08c31c8a&scoped=true"
import script from "./UploadFolder.vue?vue&type=script&lang=js"
export * from "./UploadFolder.vue?vue&type=script&lang=js"
import style0 from "./UploadFolder.vue?vue&type=style&index=0&id=08c31c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c31c8a",
  null
  
)

export default component.exports